import { Box, Divider, styled } from "@mui/material";
import React from "react";

export const ContentRow = ({ children, right = undefined, spacing = 1 }) =>
    <Box display="flex" flexGrow={1} flexDirection="row" margin="8px 0px" alignItems="center">
        <Box display="flex" gap={spacing}>
            {children}
        </Box>
        <Box flexGrow={1} />
        <Box display="flex" gap={spacing}>
            {right}
        </Box>
    </Box>

export const PortletDivider = styled(Divider)({
    margin: '4px -16px'
});